// src/components/features/timetables/SearchResultList/TimetableSearchResultList.tsx
import type { ComponentProps } from 'preact';
import type { TimetableLineItem } from '../../../../data/useTimetableSearch';
import { CardBackdrop } from '../../../base/CardBackdrop/CardBackdrop';
import { TimetableSearchResult } from '../SearchResult/TimetableSearchResult';
// styles
import styles from './TimetableSearchResultList.module.css';

export interface TimetableSearchResultListProps extends Omit<
  ComponentProps<'ul'>,
  'children'
> {
  lines: TimetableLineItem[];
  onSelectLine?: (line: TimetableLineItem) => void;
}

/**
 * Lists available timetable search results.
 *
 * Intended to wrap multiple TimetableSearchResult entries.
 */
export function TimetableSearchResultList({
  lines,
  onSelectLine,
  ...props
}: TimetableSearchResultListProps) {
  return (
    <CardBackdrop scroll="y">
      <ul
        data-component="Timetable Search Results List"
        className={styles.container}
        {...props}
      >
        {lines.map((line) => (
          <TimetableSearchResult
            key={line.id}
            line={line}
            onSelectLine={onSelectLine}
          />
        ))}
      </ul>
    </CardBackdrop>
  );
}
